import { useEffect, useState } from "react";
import { SchemaData, UseGetItemProps } from "./types";
import UISchemaEdit from "../schema/UISchemaEdit.json";
import { GET_ITEM_QUERY, GetItemGql } from "../queries/getItem";
import { removeNullValues } from "utils/removeNullValues";
import { ApiAuthRequest } from "data/ApiAuth";
import useTemplate from "./useTemplate";

const useGetItem = ({ setState, setTemplate, queryParam }: UseGetItemProps<SchemaData>) => {
  const [responseData, setResponseData] = useState<SchemaData>();
  const { templateSchema } = useTemplate();

  useEffect(() => {
    if (!!queryParam) {
      setState((props) => ({ ...props, messageError: undefined, criticalError: undefined }));
      ApiAuthRequest<GetItemGql>({
        query: GET_ITEM_QUERY,
        variables: { id: queryParam },
      })
        .then((response) => {
          if (!response?.data?.data?.findOneUser) {
            throw new Error("Não encontrado", {
              cause: { response: response?.data || response },
            });
          }

          const { role, permissions, ...data } = response.data.data?.findOneUser;

          setResponseData(
            removeNullValues({
              ...data,
              roleId: role?.id,
              permissionsIds: permissions?.map(({ id }) => id),
              password: undefined,
              birthDate: data.birthDate.split("T")[0],
            })
          );
        })
        .catch((error) => {
          console.log({ error });

          setState((prev) => ({
            ...prev,
            criticalError: error?.response?.data?.errors?.[0] || error,
          }));
        });
    }
  }, [queryParam]);

  useEffect(() => {
    if (templateSchema && responseData) {
      setTemplate({
        schemaJson: templateSchema,
        UISchema: UISchemaEdit,
      });

      setState({
        data: responseData,
      });
    }
  }, [templateSchema, responseData]);
};

export default useGetItem;
